import { Dropdown } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Check, EllipsisVertical, User, X } from 'lucide-react';

const stop = (event) => event.stopPropagation();

/**
 * Row actions menu — same kebab `Dropdown` pattern as Instances (`InstanceRowCard`).
 */
const RequestRowActionsMenu = ({ name, onOpen, onApprove, onReject, onAssign }) => {
  const { t } = useTranslation('admin-studio');

  return (
    <div className="flex justify-end" onClick={stop} onKeyDown={stop}>
      <Dropdown
        align="right"
        usePortal
        trigger={
          <button
            type="button"
            className="inline-flex size-8 items-center justify-center rounded-md text-content-muted transition-colors hover:bg-surface-hover-subtle hover:text-content"
            aria-label={t('integrations.requests.inbox.actions.menuAria', { name })}
          >
            <EllipsisVertical size={16} aria-hidden="true" />
          </button>
        }
      >
        <Dropdown.Item onClick={onOpen}>{t('integrations.requests.inbox.actions.open')}</Dropdown.Item>
        <Dropdown.Item icon={Check} onClick={onApprove}>
          {t('integrations.requests.inbox.actions.approve')}
        </Dropdown.Item>
        <Dropdown.Item icon={X} variant="danger" onClick={onReject}>
          {t('integrations.requests.inbox.actions.reject')}
        </Dropdown.Item>
        <Dropdown.Item icon={User} onClick={onAssign}>
          {t('integrations.requests.inbox.actions.assign')}
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
};

export default RequestRowActionsMenu;
